
<template>
    <!--<transition name="fade" :duration="1000">
        <div v-show="loading" class="row" style="width:100%; position:absolute;text-align:center; vertical-align:central">

            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
            <span class="sr-only">Loading...</span>

        </div>
    </transition>-->
    <div v-show="!loading">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: ['loading']
    }
</script>


// WEBPACK FOOTER //
// loaderControl.scp.html?16a1ba5c